import { render } from "./PostHeader.vue?vue&type=template&id=3761a196&scoped=true"
import script from "./PostHeader.vue?vue&type=script&lang=js"
export * from "./PostHeader.vue?vue&type=script&lang=js"

import "./PostHeader.vue?vue&type=style&index=0&id=3761a196&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3761a196"]])

export default __exports__